import { Answers, ScenarioType, Steps } from '../state/interfaces'
import { getLocale } from '../i18n/locale'
import { getCookie } from '../scenarios'

const locale = getLocale()

export function getPathname(scenarioType: string): string {
  switch (scenarioType) {
    case ScenarioType.MOBILE:
    case ScenarioType.MOBILE_ALERT:
    case ScenarioType.MOBILE_ALERT_OBSERVER:
    case ScenarioType.MOBILE_SEARCH_EMAIL:
    case ScenarioType.QUICK_SEARCH_MOBILE:
      return locale === 'en' ? 'compare-cellphone-plan' : 'comparer-forfait-cellulaire'
    case ScenarioType.INTERNET:
    case ScenarioType.INTERNET_ALERT:
    case ScenarioType.INTERNET_ALERT_OBSERVER:
    case ScenarioType.COMPETITION_INTERNET_ALERT:
    case ScenarioType.INTERNET_SPEED:
      return locale === 'en' ? 'compare-internet-plan' : 'comparer-forfait-internet'
    case ScenarioType.ADVISE_INTERNET:
      return 'advise/internet'
    default:
      return ''
  }
}

export function generateQueryUrlFragment(
  scenarioType: string,
  answers: Answers,
  scenarioAdditionalInformation: Record<string, unknown>,
): string {
  switch (scenarioType) {
    case ScenarioType.MOBILE:
    case ScenarioType.MOBILE_ALERT:
    case ScenarioType.MOBILE_ALERT_OBSERVER:
    case ScenarioType.MOBILE_SEARCH_EMAIL:
    case ScenarioType.QUICK_SEARCH_MOBILE:
      const providers = getProvidersList(scenarioAdditionalInformation)
      const data = answers[Steps.HOW_MUCH_DATA]![0].match(/\d+(MB|Mo)/i)
        ? answers[Steps.HOW_MUCH_DATA]![0]
        : answers[Steps.SLIDER_DATA]![0]
        ? answers[Steps.SLIDER_DATA]![0]
        : '0MB'
      const options = extractOptions(answers)
      return `/${
        answers[Steps.HOW_MANY_CALLING_MINUTES] ? answers[Steps.HOW_MANY_CALLING_MINUTES]![0] : 'unlimitedcalls'
      }.${data}.${options}2years.${
        answers[Steps.PHONE_MODEL_ID] ? answers[Steps.PHONE_MODEL_ID]![0] : '2'
      }.${providers}`
    case ScenarioType.INTERNET:
      const cookiePostalCode = getCookie('internetSearchPostalcode').replace(/\s+/, '')
      const postalCodeInternet = cookiePostalCode
        ? cookiePostalCode
        : answers[Steps.POSTAL_CODE]
        ? answers[Steps.POSTAL_CODE]![0].replace(/\s+/, '')
        : 'nc'
      const internetUsageInternet: string | number = answers[Steps.MONTHLY_USAGE]![0]
      const downloadSpeedInternet = answers[Steps.DOWNLOAD_SPEED]![0]
      return `/?searchSlug=search&locality=nc&bandwidth=${internetUsageInternet}&postal=${postalCodeInternet}&downloadspeed=${downloadSpeedInternet}Mbps&uploadspeed=0Mbps&services=1year&provider=all-carriers`
    case ScenarioType.INTERNET_ALERT:
    case ScenarioType.INTERNET_ALERT_OBSERVER:
    case ScenarioType.COMPETITION_INTERNET_ALERT:
      const postalCodeInternetAlert = getCookie('internetSearchPostalcode').replace(/\s+/, '')
      const internetUsageInternetAlert = 0
      // answers[Steps.MONTHLY_USAGE]![0] === 'unlimited'
      //   ? 'unlimited-data'
      //   : Number(answers[Steps.MONTHLY_USAGE]![0].replace(/GB/, '')) * 1000
      const downloadSpeedInternetAlert = answers[Steps.INTERNET_SPEED]![0]
      const downloadSpeedInternetAlertValue = downloadSpeedInternetAlert.replace(/mbps/i, '')
      return `/?searchSlug=search&locality=nc&bandwidth=${internetUsageInternetAlert}&postal=${postalCodeInternetAlert}&downloadspeed=${downloadSpeedInternetAlertValue}Mbps&uploadspeed=0Mbps&services=1year&provider=all-carriers`
    case ScenarioType.ADVISE_INTERNET:
      const internetUsageInternetProvider: string | number = answers[Steps.MONTHLY_USAGE]![0]
      const downloadSpeedInternetProvider = answers[Steps.DOWNLOAD_SPEED]![0]
      const provider = scenarioAdditionalInformation?.internetEstimationProvider || 'undefined'
      return `/?dyn=1&bandwidth=${internetUsageInternetProvider}&downloadspeed=${downloadSpeedInternetProvider}Mbps&provider=${provider}`
    // case ScenarioType.QUICK_SEARCH_MOBILE:
    //   return `/${answers[Steps.HOW_MANY_CALLING_MINUTES]![0]}.${data}.${options}2years.${
    //     answers[Steps.PHONE_MODEL_ID] ? answers[Steps.PHONE_MODEL_ID]![0] : '2'
    //   }.all-carriers`
    case ScenarioType.INTERNET_SPEED:
      const cookiePostalCodeISpeed = getCookie('internetSearchPostalcode').replace(/\s+/, '')
      const internetUsageInternetSpeed: string | number = answers[Steps.MONTHLY_USAGE]![0]
      const downloadSpeedInternetSpeed = answers[Steps.DOWNLOAD_SPEED]![0]
      const postalCodeInternetSpeed = cookiePostalCodeISpeed
        ? cookiePostalCodeISpeed
        : answers[Steps.POSTAL_CODE]
        ? answers[Steps.POSTAL_CODE]![0].replace(/\s+/, '')
        : 'nc'
      return `/?searchSlug=search&locality=nc&bandwidth=${internetUsageInternetSpeed}&postal=${postalCodeInternetSpeed}&downloadspeed=${downloadSpeedInternetSpeed}Mbps&uploadspeed=0Mbps&services=1year&provider=all-carriers`
    default:
      return ''
  }
}

export function extractOptions(answers: Answers) {
  if (answers[Steps.CALLING_OPTIONS]) {
    if (answers[Steps.CALLING_OPTIONS]?.length === 0) {
      return '3G.4G.5G.'
    }
    return answers[Steps.CALLING_OPTIONS]?.join('.') + '.'
  }
  return '3G.4G.5G.unlimitedtext.voicemail.'
}

export function getProvidersList(scenarioAdditionalInformation: Record<string, unknown>) {
  if (scenarioAdditionalInformation?.providerIdQuickSearch) {
    return scenarioAdditionalInformation.providerIdQuickSearch
  }

  return 'all-carriers'
}
